module.exports = __webpack_public_path__ + "img/location.24bcfeac.svg";